import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {server} from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class PersonalDetailsDataService {
  constructor(private http:HttpClient) { }
  create(personalDetailsData:any){
    return this.http.post<any>(`${server}personaldetailsdata`,personalDetailsData);
  }
  update(personalDetailsId,personalDetailsData){
    return this.http.put<any>(`${server}personaldetailsdata/${personalDetailsId}`,personalDetailsData);
  }
  updateDataEntryStatus(caseId,personalDetailsData){
    return this.http.put<any>(`${server}personaldetailsdata/updatedataentrystatus/${caseId}`,personalDetailsData);
  }
  updateInputqcStatus(caseId,personalDetailsData){
    return this.http.put<any>(`${server}personaldetailsdata/updateinputqcstatus/${caseId}`,personalDetailsData);
  }
  read(personalDetailsId){
    return this.http.get<any>(`${server}personaldetailsdata/${personalDetailsId}`);
  }
  readForCde(personalDetailsId,accessToken){
    return this.http.get<any>(`${server}personaldetailsdataforcde/${personalDetailsId}?access_token=${accessToken}`);
  }
  createForCde(personalDetailsData:any,accessToken){
    return this.http.post<any>(`${server}personaldetailsdataforcde?access_token=${accessToken}`,personalDetailsData);
  }
  updateForCde(personalDetails_id,personalDetailsData:any,accessToken){
    return this.http.put<any>(`${server}personaldetailsdataforcde/${personalDetails_id}?access_token=${accessToken}`,personalDetailsData);
  }
  findOneForCde(component,caseId){
    return this.http.get<any>(`${server}${component}forcde/findone/${caseId}`);
  }

}
